module.exports = __webpack_public_path__ + "img/Centennial_hall_1045_20141753_6of10.c2969c85.jpg";